import React, {Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import date from 'date-and-time';

import HeaderEjercicios from '../../../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../../../Escritorio/Instrucciones';
import useConfigAuth from '../../../../../../Hooks/useConfigAuth';
import BotoneraBottom from '../../../../Compartidos/BotoneraBottom';

import { finalizarEjercicioAction, setearEjercicioAction, setearUrlAnteriorAction } from '../../../../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../../../../actions/almacenarEjercicioActions';

import { Flex, FlexFull, ImgDrag, AvanzarImg, AvanzarBtn, InputM68, P, ImgB10 } from '../../../../../Css/StyledMatematica' ;
import { Btn, ImgBottom } from '../../../../../Css/MetodosCSS/StyledSilabas';

const instrucciones = 'Resuelve la división.';
const miniInstrucciones = 'Resuelve la división.';

const M121 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [ejercicios, setEjercicios] = useState([]); // array de ejercicios
    const [origen, setOrigen] = useState([]);         // array de arrays: origen por ejercicio
    const [destinos, setDestinos] = useState([]);     // array de arrays: destinos por ejercicio
    const [selected, setSelected] = useState(null);   // { ejIndex, from: 'origen'|'destino', itemIndex, item }
    const [numero1, setNumero1] = useState('');
    const [numero2, setNumero2] = useState('');
    const [numero3, setNumero3] = useState('');
    const [isIncorrect, setIsIncorrect] = useState(false);
    const [isCorrect, setIsCorrect] = useState(false);
    const [contarErrores, setContarErrores] = useState(0);
    const [contarTiempo, setContarTiempo] = useState([]);
    const [ultimoTiempo, setUltimoTiempo] = useState(false);
    const [erroresOrden, setErroresOrden] = useState([]);
    const [ayuVisual, setAyuVisual] = useState(false);
    const [ayuVisualSolicitada, setAyuVisualSolicitada] = useState(false);
    const indexes = 2;

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const sesion = useSelector((state) => state.ejercicio.sesion);
    const lista_usada = useSelector(state => state.informacion.lista_usada);

    const GoodWork = () => new Audio('/sounds/sonido_bien.mp3').play();
    const TryAgain = () => new Audio('/sounds/sonidoMal.mp3').play();

    const verificar = (e) => {
        e.preventDefault();
        const ej = ejercicios[count-1]; 
        const { cantidad_1, cantidad_2 } = ej;
        const porDestino = cantidad_1 / cantidad_2;

        // ------------ CHECKCORRECT (adentro) ----------------
        const checkCorrect = () => {
            // 1) Validar destinos
            const destinosEj = destinos[count-1] ?? [];

            console.log(destinosEj)
            const destinosOK = destinosEj.every(dest => 
                Array.isArray(dest) && dest.length === porDestino
            );

            if (!destinosOK) return false;

            // 2) Validar los inputs
            const numerosOk = 
                Number(numero1) == cantidad_1 &&
                Number(numero2) == cantidad_2 &&
                Number(numero3) == porDestino;

            return numerosOk;
        };
        // -----------------------------------------------------

        if (checkCorrect()) {
            // ------------------- CORRECTO -------------------
            setDisable(true);
            setIsCorrect(true);
            if(count === 1){
                setErroresOrden([...erroresOrden, contarErrores]);
            } else {
                const err = contarErrores - erroresOrden.reduce((partialSum, a) => partialSum + a, 0);
                setErroresOrden([...erroresOrden, err]);
            }
            GoodWork();
            if(count < indexes){
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setIsCorrect(false);
                    setNumero1('');
                    setNumero2('');
                    setNumero3('');
                }, 1500);
            } else {
                setUltimoTiempo(true);
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 1500);
            }
        } else {
            setDisable(true);
            setIsIncorrect(true);
            setContarErrores(contarErrores + 1);
            TryAgain();
            setTimeout(() => {
                setIsIncorrect(false);
                setDisable(false);
                setNumero1('');
                setNumero2('');
                setNumero3('');
            }, 300);
        }
    };

    const setearAyuVisual = (e) => {
        e.preventDefault();
        if (ayuVisual) {
            setAyuVisual(false);
        } else {
            setAyuVisual(true);
        }
        if(ayuVisualSolicitada){
            return;
        } else {
            setAyuVisualSolicitada(true);
        }
    }

    // Handlers: pick (seleccionar) y drop (soltar)
    // --------------------------------------------
    const handleSelectFromOrigen = (ejIndex, itemIndex) => {
        const item = (origen[ejIndex] || [])[itemIndex];
        if (!item) return;
        setSelected({ ejIndex, from: "origen", itemIndex, item });
    };

    const handleSelectFromDestino = (ejIndex, destIdx, itemIndex) => {
        const slot = (destinos[ejIndex] || [])[destIdx] || [];
        const item = slot[itemIndex];
        if (!item) return;
        setSelected({ ejIndex, from: "destino", destIdx, itemIndex, item });
    };

    // soltar en un slot concreto (destIdx)
    const handleDropToDest = (ejIndex, destIdx) => {
        if (!selected) return;
        if (selected.ejIndex !== ejIndex) return; // no permitir mezclar ejercicios

        // evitar soltar si ya existe exactamente el mismo id en ese slot
        const slot = (destinos[ejIndex] || [])[destIdx] || [];
        if (slot.some((it) => it && it.id === selected.item.id)) {
        setSelected(null);
        return;
        }

        // copiar estructuras (inmutables)
        const origenCopy = origen.map((arr) => [...arr]);
        const destCopy = destinos.map((arr) => arr.map((s) => [...s]));

        // quitar del origen si venía de ahi
        if (selected.from === "origen") {
        origenCopy[ejIndex] = origenCopy[ejIndex].filter((_, i) => i !== selected.itemIndex);
        } else if (selected.from === "destino") {
        // quitar de su slot de origen
        const fromSlotIdx = selected.destIdx;
        destCopy[ejIndex][fromSlotIdx] = destCopy[ejIndex][fromSlotIdx].filter((_, i) => i !== selected.itemIndex);
        }

        // agregar al slot destino
        destCopy[ejIndex][destIdx].push(selected.item);

        setOrigen(origenCopy);
        setDestinos(destCopy);
        setSelected(null);
    };

    const handleResetEjercicio = (ejIndex) => {
        const origenCopy = origen.map((arr) => [...arr]);
        const destCopy = destinos.map((arr) => arr.map((s) => [...s]));

        // tomar todo lo que esté en todos los slots destino
        const allItems = destCopy[ejIndex].flat();

        // vaciar destinos
        destCopy[ejIndex] = destCopy[ejIndex].map(() => []);

        // devolver todo al origen
        origenCopy[ejIndex] = [...origenCopy[ejIndex], ...allItems];

        setOrigen(origenCopy);
        setDestinos(destCopy);
        setSelected(null);
    };

    useEffect(() => {
        const imagenes = [
            { imagen_url_1: "/img/abeja.png", imagen_url_2: "/img/flor_roja.png"},
            { imagen_url_1: "/img/ardilla.png", imagen_url_2: "/img/arbol.png"},
            { imagen_url_1: "/img/banana.png", imagen_url_2: "/img/mono.png"},
            { imagen_url_1: "/img/zanahoria.png", imagen_url_2: "/img/conejo.png"},
            { imagen_url_1: "/img/hueso.png", imagen_url_2: "/img/perro.png"}
        ];
        const pool = [...imagenes].sort(() => Math.random() - 0.5).slice(0, 2);

        const ejerciciosGenerados = [];
        const origenTemp = [];
        const destinosTemp = [];

        pool.forEach((imgObj, ejIdx) => {
        // cantidad_1 entre 2 y 14
        const cant1 = Math.floor(Math.random() * 13) + 2;

        // divisores válidos (1..5 o hasta cant1)
        const posibles = [];
        for (let d = 1; d <= Math.min(5, cant1); d++) {
            if (cant1 % d === 0) posibles.push(d);
        }
        const cant2 = posibles[Math.floor(Math.random() * posibles.length)];

        ejerciciosGenerados.push({
            imagen_url_1: imgObj.imagen_url_1,
            imagen_url_2: imgObj.imagen_url_2,
            cantidad_1: cant1,
            cantidad_2: cant2,
            porDestino: cant1 / cant2,
            cuenta: `${cant1} / ${cant2}`
        });

        // crear origen: items con id único por ejercicio
        const origenItems = Array.from({ length: cant1 }, (_, i) => ({
            id: `ej${ejIdx}-item-${i}`,
            img: imgObj.imagen_url_1,
        }));

        // crear destinos: array de cant2 slots (cada slot será array para permitir varios items si queremos)
        // aquí dejamos cada slot como array vacío (puede contener varios items si decidís ese comportamiento)
        const destSlots = Array.from({ length: cant2 }, () => []);

        origenTemp.push(origenItems);
        destinosTemp.push(destSlots);
        });

        setEjercicios(ejerciciosGenerados);
        setOrigen(origenTemp);
        setDestinos(destinosTemp);
        setSelected(null);
    }, []);

    useEffect(() => {
        dispatch(setearEjercicioAction('M121') );
        dispatch(setearUrlAnteriorAction('matematica/calculo/division/ejercitacion'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(iniciar === false && count === indexes){
            return;
        }else if(iniciar === false && count === 1){
            return;
        } else {
            const newList = JSON.parse(JSON.stringify(contarTiempo));
            newList.push(new Date());
            setContarTiempo(newList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iniciar,count, ultimoTiempo]);

    useEffect(() => {
        if(finalizar){
            const tiempo = JSON.parse(JSON.stringify(contarTiempo));
            const conseguirTiempos = (a) => {
                const t = [];
                for (let i = 0; i < a.length - 1; i++){
                    const despues = new Date(a[i+1]);
                    const antes = new Date(a[i])
                    const segundos = Math.round((date.subtract(despues, antes).toSeconds())*10)/10;
                    t.push(segundos);
                }
                return t
            }
            const tiempoFinal = conseguirTiempos(tiempo);

            const informacion = {
                config,
                payload: {
                'ejercicio': "M121",
                'errores': contarErrores,
                'tiempo': tiempoFinal,
                'id_paciente': id_paciente,
                'erroresOrden': erroresOrden,
                'info_ejercicio': ejercicios,
                'lista_usada': lista_usada,
                'ayuda_visual': ayuVisualSolicitada,
                sesion
                }
            }

            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    if (ejercicios.length === 0) return <div>Cargando ejercicios...</div>;

    // índice actual según count (count empieza en 1)
    const ejIndex = Math.max(0, Math.min(ejercicios.length - 1, count - 1));
    const ej = ejercicios[ejIndex];

    const origenArr = origen[ejIndex] ?? [];
    const destinosArr = destinos[ejIndex] ?? Array(ej.cantidad_2).fill([]); // slots arrays

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} minMay={false} />
            {iniciar
                ?
                <Flex direction="column" height="100%" width="100%" align="center">
                    <Flex direction="column" margin="auto" width="100%" align='center' 
                    isCorrect={isCorrect}
                    isIncorrect={isIncorrect}
                    >
                        <FlexFull alignself="end" margin="0 2rem 2rem 0" position="absolute" top="5rem">
                            <Btn bg="transparent" border="none"
                                onClick={(e) => setearAyuVisual(e)}
                            >
                                {ayuVisual ? 
                                <ImgBottom width="45px" src={`/img/ayuda_clickeado.png`} />
                                :
                                <ImgBottom width="45px" src={`/img/icono_ayuda.png`} />
                                }
                            </Btn>
                        </FlexFull>
                        <FlexFull justify="space-between" align="center" margin="0 0rem 1rem 0"
                        >
                           {origenArr.length === 0 ? (
                                <button
                                    style={{
                                    padding: "6px 12px",
                                    borderRadius: 6,
                                    border: "1px solid #888",
                                    cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    handleResetEjercicio(ejIndex);
                                    }}
                                >
                                    Traer items al origen
                                </button>
                            ) : (
                                origenArr.map((item, idx) => (
                                    <FlexFull justify="space-between" align="center" margin="auto"
                                        key={item.id}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleSelectFromOrigen(ejIndex, idx);
                                        }}
                                        style={{
                                            border: selected && selected.ejIndex === ejIndex && selected.from === "origen" && selected.itemIndex === idx ? "3px solid #0a84ff" : "1px solid #ccc",
                                            borderRadius: 6,
                                            cursor: "pointer",
                                        }}
                                    >
                                        <ImgDrag  w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0rem 0 0"
                                            src={item.img} alt="" style={{ display: "block", pointerEvents: "none" }}
                                        />
                                    </FlexFull>
                                ))
                            )}
                        </FlexFull>
                        <FlexFull justify="center" align="center" margin="0 0 1.5rem 0" wrap={ejercicios[count-1].cantidad_2 == 5 ? "wrap" : null}>
                            {destinosArr.map((slotArr, destIdx) => (
                                <FlexFull justify="space-between" align="center" margin="0 0rem 0 0" direction="column"
                                    key={destIdx}
                                    style={{ border: "1px dashed #bbb", width: "11rem", textAlign: "center", cursor: "pointer" }}
                                    onClick={() => handleDropToDest(ejIndex, destIdx)}
                                >
                                    <ImgDrag w="8rem" wd="8rem" wlg="8rem" m="0 0 0 0" 
                                        src={ej.imagen_url_2} alt="" style={{ pointerEvents: "none" }} 
                                    />
                                    <FlexFull justify="center" align="center" margin="auto" wrap="wrap">
                                        { (slotArr || []).length === 0 ? <small style={{ color: "#999" }}>vacío</small>
                                            : (slotArr || []).map((it, i) => (
                                            <FlexFull justify="center" align="center" margin="auto"
                                                key={it.id} style={{ cursor: "pointer" }}
                                            >
                                                <ImgDrag w="2.5rem" wd="2.5rem" wlg="2.5rem" m="0 0rem 0 0"
                                                    src={it.img}
                                                    alt=""
                                                    onClick={(e) => { e.stopPropagation(); handleSelectFromDestino(ejIndex, destIdx, i); }}
                                                    style={{
                                                    border: selected && selected.ejIndex === ejIndex && selected.from === "destino" && selected.destIdx === destIdx && selected.itemIndex === i ? "3px solid #0a84ff" : "1px solid #ddd",
                                                    borderRadius: 4,
                                                    display: "block",
                                                    }}
                                                />
                                            </FlexFull>
                                        ))}
                                    </FlexFull>
                                </FlexFull>
                            ))}
                        </FlexFull>
                        <FlexFull justify="space-between" align="flex-start" margin="auto">
                            {ayuVisual ? 
                            <FlexFull>
                                <P>¿QUÉ <br /> REPARTIMOS?</P>
                            </FlexFull>
                            : null}
                            {ayuVisual ? 
                            <FlexFull>
                                <ImgB10 src={`/img/arrowRight.png`} h='3rem' tr='rotate(180deg)' />
                            </FlexFull>
                            : null}
                            <FlexFull>
                                <InputM68 type="numeric" min="1" max="20" value={numero1} onChange={(e) => setNumero1(e.target.value)} color='#FF9B2A' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2rem", width: "4rem", margin: "0 0.5rem 0 0.5rem"}} />
                            </FlexFull>
                            <FlexFull direction="column" align="center" justify="center" margin="0rem 0.5rem 0 1.5rem">
                                <P fs="2.5rem" m="0">÷</P>
                            </FlexFull>
                            <FlexFull direction="column" align="center" justify="center" >
                                <InputM68 type="numeric" min="1" max="10" value={numero2} onChange={(e) => setNumero2(e.target.value)} color='#FF9B2A' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2rem", width: "4rem", margin: "0 0.5rem 0 0.5rem"}} />
                                {ayuVisual ? 
                                <FlexFull direction="column" align="center" justify="center" height="">
                                    <ImgB10 src={`/img/arrowRight.png`} h='2rem' tr='rotate(90deg)' />
                                    <P style={{margin: "0"}}>
                                        ¿ENTRE QUIENES <br /> LO REPARTIMOS?
                                    </P>
                                </FlexFull>
                                : null}
                            </FlexFull>
                            <FlexFull align="center" justify="center" margin="0rem 1rem 0 0rem">
                                <P fs="2rem" m="0">=</P>
                            </FlexFull>
                            <FlexFull align="center" justify="center">
                                <InputM68 type="numeric" min="1" max="20" value={numero3} onChange={(e) => setNumero3(e.target.value)} color='#FF9B2A' bs='inset 0px 4px 4px rgba(0, 0, 0, 0.25)' bradius='20px' style={{fontSize: "2rem", width: "4rem", margin: "0 0.5rem 0 0.5rem"}} />
                            </FlexFull>
                            {ayuVisual ? 
                            <FlexFull align="center" justify="center" height="">
                                <ImgB10 src={`/img/arrowRight.png`} h='3rem' />
                                <P>
                                    ¿CUÁNTOS RECIBE <br /> CADA UNO?
                                </P>
                            </FlexFull>
                            : null}
                        </FlexFull>
                    </Flex>

                    <Flex margin="0 0rem 0.5rem 0rem" width="90%" justify="space-between">
                        <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                        <AvanzarBtn
                            disabled={disable}
                            onClick={(e) => verificar(e)}
                        >
                            <AvanzarImg src={'/img/play.png'} /> 
                        </AvanzarBtn>
                    </Flex>
                </Flex>
                :
                    <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
  );
}
 
export default M121;